// @flow

import Q from 'q';
import $ from 'jquery';
import _ from 'lodash';

import server, { lkRoute } from 'server2';

import TraceKit from 'rgs-tracekit';
import spyInfo from 'user-info-spy';
import config from 'config';

import 'ko-component-myrgs-auth2-form';

import { root as rootLogContext } from 'log-context';
import { LkSplunkLogger } from 'splunk-logger';
import { fetchYandexSmartCaptchaJsOnce	} from "yandex-smart-captcha";

import { EMAIL_INFO_KEY } from 'user-info-spy-prefilling';

import Controller from './js/controller';
import Dictionaries from './js/dictionaries';
import * as observableServerTime from 'observable-server-time';
const VIEW_SELECTOR = '#page-my-login-view';


function init () {
	TraceKit.notifications = true;

	const domReady = Q.promise(resolve => $(resolve));

	const logContext = rootLogContext.subcontext({
		splunkLogger: new LkSplunkLogger(),
	});

	// Нужно для captcha на форме логина, но грузим уже здесь, заранее
	fetchYandexSmartCaptchaJsOnce();

	const getPersonalDataProcessingInfo = async () => {
		return await server.any.cmsapi.get([
			'cmsContent',
			'pdn',
		], {
			query: {
				pdnType: 'myrgs_personal_data_processing_info',
			},
		});
	};

	const getDmsPdnContent = async () => {
		return await server.any.rest.get([
			'lk',
			'profiles',
			'my',
			'dms',
			'policies',
			'pdAgreement',
		]);
	};

	const configReady = Q.all([
		config.cms.pageUrls.get(),
		config.cms.siteID.get(),
		getPersonalDataProcessingInfo(),
		getDmsPdnContent(),
	])
		// eslint-disable-next-line max-len
		.spread((pageUrls, siteID, { responseJSON: { PdnText } }, { responseJSON: { StatusText } }) => {

			return { cms: { pageUrls, siteID, pdn: PdnText, dmsPdn: StatusText } };
		});

	const dictsReady = Q.all([
		server.any.rest.get([
			lkRoute.prefix,
			lkRoute.data,
			lkRoute.physical,
			lkRoute.documentTypes,
		]),
	])
		.then(responses => _.map(responses, 'responseJSON.Data'))
		.spread(documentTypes => {
			const dictionaries = new Dictionaries();

			dictionaries.loadData({ documentTypes });

			return dictionaries;
		});

	Q.all([
		dictsReady,
		configReady,
		observableServerTime.ready(),
		domReady,
	])
		.spread((dictionaries, config) => {
			let prefilling = {};

			if (spyInfo.isSet(EMAIL_INFO_KEY)) {
				prefilling = { Email: spyInfo.get(EMAIL_INFO_KEY) };
			}

			const view = $(VIEW_SELECTOR)[0];
			const params = {
				logContext,
				prefilling,
				dictionaries,
				config,
			};

			const pageMyLoginController = new Controller({view, params});

			require('debug-globals').extend({ pageMyLoginController });
		})
		.then(() => {
			require('page-my-common/js/content-fade-in')();
		})
		.catch(e => {
			$(VIEW_SELECTOR).hide();
			throw e;
		})
		.done();
}

init();
